import { render, staticRenderFns } from "./ProjectIsOnHoldPopup.vue?vue&type=template&id=116d52e3"
import script from "./ProjectIsOnHoldPopup.vue?vue&type=script&lang=ts"
export * from "./ProjectIsOnHoldPopup.vue?vue&type=script&lang=ts"
import style0 from "./ProjectIsOnHoldPopup.vue?vue&type=style&index=0&id=116d52e3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports